export const camelToSnakeCase = (str: string): string =>
  str.replace(/[A-Z]/g, (character) => `_${character.toLowerCase()}`);
